import { render } from "./PdfRowMangel.vue?vue&type=template&id=a75ca704&ts=true"
import script from "./PdfRowMangel.vue?vue&type=script&lang=ts"
export * from "./PdfRowMangel.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__